import React from "react";
import Api from "../../services/api";
import TopBar from "../../Components/topBar/topBar";
import TextField from "../../Components/textField/textField";
import Button from "../../Components/commonButton/commonButton";
import Alert from "../../Components/alert/Alert";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Select from "../../Components/select/select";
import HeaderForms from "../../Components/headerForms/HeaderForms";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import "./userPreference.css";

export default class UserPreference extends React.Component {
  state = {
    username: "",
    id_user: null,
    password: "",
    newPassword: "",
    fullname: "",
    email: "",
    show: false,
    message: "",
    confirmPassword: "",
    logo: null,
    vPswd: false,
    shifts:[{value:0,label:"Turno 0"}],
    selectedID:"",
    id_shift:0
  };

  componentDidMount() {
    let id_user = localStorage.getItem("@oee-monitor/id");
    Api.get(`/users/${id_user}`)
      .then((resp) => {
        console.log(resp);
        const { username, email,id_work_shift } = resp.data;
        this.setState({ username: username, email: email,id_shift:id_work_shift});

        Api.get('/work-shifts/').then(({status,data})=>{
          if(status === 200){
            let auxarr = []
            data.forEach(({id,code}) => {
              auxarr.push({value:id,label:code})
            });
            const result = auxarr.find((e)=>e.value === this.state.id_shift)
            this.setState({shifts:[...auxarr],selectedID:result})
          }
        }).catch((err)=>{
          console.log(err)
        })
      
      })
      .catch((error) => {
        this.setState({ message: "Erro de conexão", show: true });
      });

      
    this.setState({ id_user: id_user });
  }

  callBackUser = (child) => {
    this.setState({ username: child });
  };
  callBackEmail = (child) => {
    this.setState({ email: child });
  };
  callBackPassword = (child) => {
    this.setState({ newPassword: child });
  };
  callBackConfirmPassword = (child) => {
    this.setState({ confirmPassword: child });
  };
  onFileChange = (event) => {
    this.setState({ logo: event.target.files[0] });
  };
  callbackfunction = () => {
    this.setState({ show: false });
  };

  sendData = () => {
    const {username,fullname,email,id_user,logo,id_shift} = this.state;
    
    Api.put(`/users/${id_user}`, {
      username: username,
      fullname: fullname,
      id_work_shift:id_shift,
      email: email
    })
      .then((resp) => {
        if (resp.data.verify) {
          this.setState({
            message:
              resp.data.username +
              "\n" +
              resp.data.email,
            show: true,
          });
        } else {
          localStorage.setItem("@oee-monitor/user", this.state.username);
          /* this.setState({ message: "Dados atualizados.", show: true }); */
          window.location.reload()
        }
      })
      .catch((error) => {
        if (error.response) {
          alert(
            JSON.stringify(error.response.data) +
            "\n" +
            error.response.status +
            "\n" +
            JSON.stringify(error.response.headers)
          );
        }
        this.setState({
          message: "" + JSON.stringify(error.response.data),
          show: true,
        });
      });
  };

  handleSelectShift = (element) => {
    const {value,label} = this.state.shifts.find((v) => v.value == element);
    this.setState({selectedID:[{value:value,label:label}]})
    this.setState({id_shift:value})
  };

  render() {
    const { show, message, email,shifts,selectedID } = this.state;

    return (
      <>
        <main className="user-preference-main">
          <div className="UserPreference-container">
          <HeaderForms text="Dados pessoais" icon={faInfoCircle}/>
            {show ? (
              <Alert
                show={show}
                message={message}
                parentCallback={this.callbackfunction}
              />
            ) : null}
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              <form encType="multipart/form-data"  >
                <div>
                  <TextField
                    title="Usuário"
                    typeValue="text"
                    value={this.state.username}
                    altType={true}
                    maxLength={20}
                    parentCallback={this.callBackUser}
                  />
                </div>
                <div>
                <Select autoSelect={true} 
                  selectedID={selectedID} 
                  label="Turno" 
                  handleSelect={this.handleSelectShift} 
                  arrData={shifts} 
                />
                </div>
                <div>
                  <TextField
                    title="Email"
                    typeValue="email"
                    value={email}
                    altType={true}
                    maxLength={30}
                    parentCallback={this.callBackEmail}
                  />
                </div>
                {/* <div>
              <TextField
                title="Nova senha"
                typeValue={"password"}
                maxLength={60}
                parentCallback={this.callBackPassword}
              />
            </div>
            <div>
              <TextField
                title="Confirme a senha"
                typeValue="password"
                maxLength={60}
                parentCallback={this.callBackConfirmPassword}
              />
            </div> 
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontWeight: 'bold' }} for="image">Logo da empresa:</label>
                  <input id={'image'} type="file" onChange={this.onFileChange} accept=".jpg, .jpeg, .png"></input>
                </div>*/}
                
                <div className="submitButton d-flex justify-content-end"><Button noMargin title="Salvar Dados" icon="save" parentCallback={this.sendData} /></div>
              </form>
            </div>
          </div>
        </main>
        <BottomBar></BottomBar>
      </>
    );
  }
}